import { RESET_APPLICATION_DETAIL } from './constants';

export const resetApplicationDetail = () => ({
    type: RESET_APPLICATION_DETAIL,
});
